import React, { useRef, useEffect, forwardRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const AnimatedTitle = forwardRef(({ text, sx = {}, whiteColor=false }, ref) => {
  const titleRef = useRef(null);
  const actualRef = ref || titleRef;

  useEffect(() => {
    const element = actualRef.current;
    if (!element) return;

    gsap.fromTo(
      element.querySelectorAll(".char"),
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        stagger: 0.05,
        duration: 0.8,
        ease: "back.out(1.7)",
        scrollTrigger: {
          trigger: element,
          start: "bottom bottom",
          end: "top top",
          toggleActions: "play none none reverse",
        },
      }
    );

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [actualRef]);

  return (
    <Typography
      ref={actualRef}
      component="h2"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        fontWeight: 600,
        fontSize: { xs: "26px", md: "64px" },
        color: whiteColor ? "#fff" : "rgba(11, 25, 62, 1)",
        textTransform: "uppercase",
        ...sx,
      }}
    >
      {text.split("").map((char, idx) => (
        <Box
          key={idx}
          component="span"
          className="char"
          sx={{ whiteSpace: 'pre' }} 
        >
          {char === " " ? "\u00A0" : char}
        </Box>
      ))}
    </Typography>
  );
});

AnimatedTitle.displayName = 'AnimatedTitle';

export default AnimatedTitle;
